<template>
  <transition name="fade">
    <div
      v-show="$store.state.show === 'page9'"
      :class="['page page9', $store.state.show === 'page9' ? 'active' : '']"
    >
      <div class="content">
        <div class="cont">
          <img src="./images/p9-p1-yanzi.png" alt="" class="p1-yanzi abs" />

          <div :class="['screen screen1', $store.state.screen === 'screen18' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p9-p1-text.png" alt="" class="p1-text abs opacity" />
            <img src="./images/p9-p1-tips1.png" alt="" class="p1-tips1 abs opacity" />
            <img src="./images/p9-p1-tips2.png" alt="" class="p1-tips2 abs opacity" />
            <img src="./images/p9-p1-yanzi1.png" alt="" class="p1-yanzi1 p1-yanzi abs" />
          </div>

          <img src="./images/p9-p1-chuan.png" alt="" class="p1-chuan abs opacity" />

          <div :class="['screen screen2', $store.state.screen === 'screen19' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p9-p2-text.png" alt="" class="p2-text abs opacity" />
            <img src="./images/p9-p1-yanzi1.png" alt="" class="p1-yanzi1 p1-yanzi abs" />
          </div>

          <div :class="['screen screen3', $store.state.screen === 'screen20' ? 'active' : '' ? 'active' : '']">
            <img src="./images/p9-p3-text.png" alt="" class="p3-text abs opacity" />
            <img src="./images/p9-p1-yanzi1.png" alt="" class="p1-yanzi1 p1-yanzi abs" />
          </div>

          <img src="./images/p9-p1-molihua.png" alt="" class="p1-molihua abs" />
        </div>
        <img src="./images/yun-zuo.png" alt="" class="yun-zuo abs" />
        <img src="./images/yun-you.png" alt="" class="yun-you abs" />
        <!-- <img :class="['tips-up abs']" src="./images/tips-up.png" alt="" /> -->
      </div>
    </div>
  </transition>
</template>

<script>
import $ from "jquery";
import { setTimeout, clearTimeout } from 'timers';
let timer1 = null
let timer2 = null
export default {
  name: "page9",
  components: {},
  data() {
    return {};
  },
  methods: {
    // 下一页
    nextPage() {
      this.$store.dispatch("setPageFn", "page9");
    },
  },
  mounted() {
  },
  watch: {
    "$store.state.screen"() {
      const that = this
      if (that.$store.state.screen === "screen18") {
        timer1 = setTimeout(() => {
          that.$store.dispatch("setScreenFn", "screen19");
          window.playAll(window.music19)
          window.music19.addEventListener('ended', function () {
            that.$store.dispatch("setScreenFn", "screen20");
          }, false);
        }, 4500)
        
      }
    },
    "$store.state.show"() {
      if (this.$store.state.show !== 'page9') {
        clearTimeout(timer1)
        clearTimeout(timer2)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/mixin";

.page9 {
  background: url("./images/p9-p1-bg.jpg") top center no-repeat;
  background-size: 100% auto;

  &.active {
    .p1-chuan  {
      -webkit-animation: identifierxlong 4.5s ease-out 0.2s;
      animation: identifierxlong 4.5s ease-out 0.2s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
    .p1-yanzi {
      -webkit-animation: identifierxr 1s ease-out 0.3s;
      animation: identifierxr 1s ease-out 0.3s;
      -webkit-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
    }
  }
  .content {

    .screen2.active {
      .p2-text {
        -webkit-animation: identifieryu 0.6s ease-out 0.2s;
        animation: identifieryu 0.6s ease-out 0.2s;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
      }
    }

    .screen3.active {
      .p3-text {
        -webkit-animation: identifieryu 0.6s ease-out 0.2s;
        animation: identifieryu 0.6s ease-out 0.2s;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
      }

      .p1-yanzi1 {
        top: -280px;
      }
    }

    .screen3 .p1-yanzi1 {
      -webkit-transition: all 0.6s ease-out;
      transition: all 0.6s ease-out;
    }

    .screen1.active {
      z-index: 50;
      
      .p1-text {
        -webkit-animation: identifieryu 0.6s ease-out 0.2s;
        animation: identifieryu 0.6s ease-out 0.2s;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
      }

      .p1-tips1 {
        -webkit-animation: identifiery 0.6s ease-out 0.4s;
        animation: identifiery 0.6s ease-out 0.4s;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
      }

      .p1-tips2 {
        -webkit-animation: identifiery 0.6s ease-out 0.3s;
        animation: identifiery 0.6s ease-out 0.3s;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
      }
    }
    .p1-yanzi {
      top: 62px;
      left: 20px;
      width: 711px;
      z-index: 13;
    }

    .p1-chuan {
      top: 782px;
      left: 0;
      width: 291px;
    }
    .p1-tips1 {
      top: 63px;
      left: 86px;
      width: 82px;
    }

    .p1-tips2 {
      top: 408px;
      right: 56px;
      width: 108px;
    }

    .p1-molihua {
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 40;
    }

    .p1-text {
      top: 894px;
      left: 38px;
      width: 686px;
    }

    .screen1 {
      z-index: 15;
    }

    .p2-text {
      top: 230px;
      left: 102px;
      width: 616px;
    }

    .p3-text {
      top: 420px;
      left: 163px;
      width: 491px;
    }
 
  }
}
</style>
